import React, { useEffect, useState } from 'react';

import { Container, Grid, Link, Typography } from '@material-ui/core';
import queryString from 'query-string';
import { useLocation, Link as RouterLink } from 'react-router-dom';

import PlanItem from '../../components/payment/PlanItem';
import { usePackagePlanStyles } from '../../components/payment/styles';
import PaymentUtils from '../../utils/payment.utils';
import useBlocRef from '../../utils/useBlocRef.hook';

/* eslint-disable */
const getStoragePlanDetails = (userPlan, classes, action) => {
  if (!userPlan) return;
  const details = {
    upgrade: {
      title: 'Upgrade your account',
      btnText: 'Select Upgrade',
      description:
        'Want to store more Imaging images? You can upgrade your storage at any time and only pay the difference for your current annual subscription. We suggest the following upgrade option(s) based on your current subscription.',
      plans: {
        basic: [
          {
            plan: PaymentUtils.STANDARD_PLAN,
            type: 'subscription',
            planName: 'Standard Storage',
            previousPrice: PaymentUtils.STANDARD_PLAN.price,
            price: PaymentUtils.calculateStandardUpgrade(userPlan.expiredAt),
            description: (
              <>
                <Typography className={classes.packageDescription}>Store up to 10 Imaging Studies</Typography>
                <Typography className={classes.packageDescription2}>(12 Month Storage Subscription)</Typography>
              </>
            ),
            billingNote: (
              <>
                <span>
                  ${PaymentUtils.calculateStandardUpgrade(userPlan.expiredAt)} until the end of your current subscription <br></br> period. Billed $
                  {PaymentUtils.STANDARD_PLAN.price} annually thereafter.
                </span>
              </>
            ),
          },
          {
            plan: PaymentUtils.DELUXE_PLAN,
            type: 'subscription',
            planName: 'Deluxe Storage',
            mostPopularText: 'BEST VALUE',
            previousPrice: PaymentUtils.DELUXE_PLAN.price,
            price: PaymentUtils.calculateDeluxeUpgradeFromBasic(userPlan.expiredAt),
            description: (
              <>
                <Typography className={classes.packageDescription}>Unlimited Imaging Study Storage</Typography>
                <Typography className={classes.packageDescription2}>(12 Month Storage Subscription)</Typography>
              </>
            ),
            billingNote: (
              <>
                <span>
                  ${PaymentUtils.calculateDeluxeUpgradeFromBasic(userPlan.expiredAt)} until the end of your current subscription <br></br> period. Billed $
                  {PaymentUtils.DELUXE_PLAN.price} annually thereafter.
                </span>
              </>
            ),
          },
        ],
        standard: [
          {
            plan: PaymentUtils.DELUXE_PLAN,
            type: 'subscription',
            planName: 'Deluxe Storage',
            previousPrice: PaymentUtils.DELUXE_PLAN.price,
            price: PaymentUtils.calculateDeluxeUpgradeFromStandard(userPlan.expiredAt),
            description: (
              <>
                <Typography className={classes.packageDescription}>Unlimited Imaging Study Storage</Typography>
                <Typography className={classes.packageDescription2}>(12 Month Storage Subscription)</Typography>
              </>
            ),
            billingNote: (
              <>
                <span>
                  ${PaymentUtils.calculateDeluxeUpgradeFromStandard(userPlan.expiredAt)} until the end of your current subscription <br></br> period. Billed $
                  {PaymentUtils.DELUXE_PLAN.price} annually thereafter.
                </span>
              </>
            ),
          },
        ],
      },
    },
    upgradePackage: {
      title: 'Upgrade your account',
      btnText: 'Select Upgrade',
      description:
        'Want to store more Imaging images? You can upgrade your storage at any time and only pay the difference for your current annual subscription. We suggest the following upgrade option(s) based on your current subscription.',
      plans: {
        basic: [
          {
            plan: PaymentUtils.STANDARD_PACKAGE,
            type: 'package',
            planName: 'Standard Package',
            previousPrice: PaymentUtils.STANDARD_PACKAGE.price,
            price: PaymentUtils.calculateUpgrade(userPlan.expiredAt, PaymentUtils.BASIC_PLAN.price, PaymentUtils.STANDARD_PACKAGE.price),
            description: (
              <>
                <Container className={`${classes.packageDescriptionContainer} mb-1`}>
                  <Typography className={classes.packageDescription}>1 Personalized Video Report</Typography>
                </Container>
                <Typography className={classes.packageDescription}>Store up to 10 Imaging Studies</Typography>
                <Typography className={classes.packageDescription2}>(6 Month Storage Upgrade)</Typography>
              </>
            ),
            billingNote: (
              <>
                <span>
                  ${PaymentUtils.calculateUpgrade(userPlan.expiredAt, PaymentUtils.BASIC_PLAN.price, PaymentUtils.STANDARD_PACKAGE.price)} until the end of your current
                  subscription <br></br> period. Billed ${PaymentUtils.STANDARD_PLAN.price} annually thereafter.
                </span>
              </>
            ),
          },
          {
            plan: PaymentUtils.DELUXE_PACKAGE,
            type: 'package',
            planName: 'Deluxe Package',
            previousPrice: PaymentUtils.DELUXE_PACKAGE.price,
            price: PaymentUtils.calculateUpgrade(userPlan.expiredAt, PaymentUtils.BASIC_PLAN.price, PaymentUtils.DELUXE_PACKAGE.price),
            description: (
              <>
                <Container className={`${classes.packageDescriptionContainer} mb-1`}>
                  <Typography className={classes.packageDescription}>1 Personalized Video Report</Typography>
                </Container>
                <Typography className={classes.packageDescription}>
                  Store <span style={{ color: '#388E3C' }}>UNLIMITED</span> Imaging Studies
                </Typography>
                <Typography className={classes.packageDescription2}>(6 Month Storage Upgrade)</Typography>
              </>
            ),
            billingNote: (
              <>
                <span>
                  ${PaymentUtils.calculateUpgrade(userPlan.expiredAt, PaymentUtils.BASIC_PLAN.price, PaymentUtils.DELUXE_PACKAGE.price)} until the end of your current subscription{' '}
                  <br></br> period. Billed ${PaymentUtils.DELUXE_PLAN.price} annually thereafter.
                </span>
              </>
            ),
          },
        ],
        standard: [
          {
            plan: PaymentUtils.DELUXE_PACKAGE,
            type: 'package',
            planName: 'Deluxe Package',
            previousPrice: PaymentUtils.DELUXE_PACKAGE.price,
            price: PaymentUtils.calculateUpgrade(userPlan.expiredAt, PaymentUtils.STANDARD_PLAN.price, PaymentUtils.DELUXE_PACKAGE.price),
            description: (
              <>
                <Container className={`${classes.packageDescriptionContainer} mb-1`}>
                  <Typography className={classes.packageDescription}>1 Personalized Video Report</Typography>
                </Container>
                <Typography className={classes.packageDescription}>
                  Store <span style={{ color: '#388E3C' }}>UNLIMITED</span> Imaging Studies
                </Typography>
                <Typography className={classes.packageDescription2}>(6 Month Storage Subscription)</Typography>
              </>
            ),
            billingNote: (
              <>
                <span>
                  ${PaymentUtils.calculateUpgrade(userPlan.expiredAt, PaymentUtils.STANDARD_PLAN.price, PaymentUtils.DELUXE_PACKAGE.price)} until the end of your current
                  subscription <br></br> period. Billed ${PaymentUtils.DELUXE_PLAN.price} annually thereafter.
                </span>
              </>
            ),
          },
        ],
      },
    },
    upload: {
      title: 'Oops, looks like you have reached your maximum amount of file uploads :-(',
      btnText: 'Select Upgrade',
      description: 'In order to upload more files to your personal medical record we suggest the following upgrade option(s) based on your current subscription.',
      plans: {
        basic: [
          {
            plan: PaymentUtils.STANDARD_PLAN,
            type: 'subscription',
            planName: 'Standard Storage',
            previousPrice: PaymentUtils.STANDARD_PLAN.price,
            price: PaymentUtils.calculateStandardUpgrade(userPlan.expiredAt),
            description: (
              <>
                <Typography className={classes.packageDescription}>Store up to 10 Imaging Studies</Typography>
                <Typography className={classes.packageDescription2}>(12 Month Storage Subscription)</Typography>
              </>
            ),
            billingNote: (
              <>
                <span>
                  ${PaymentUtils.calculateStandardUpgrade(userPlan.expiredAt)} until the end of your current subscription <br></br> period. Billed $
                  {PaymentUtils.STANDARD_PLAN.price} annually thereafter.
                </span>
              </>
            ),
          },
          {
            plan: PaymentUtils.DELUXE_PLAN,
            type: 'subscription',
            planName: 'Deluxe Storage',
            mostPopularText: 'BEST VALUE',
            previousPrice: PaymentUtils.DELUXE_PLAN.price,
            price: PaymentUtils.calculateDeluxeUpgradeFromBasic(userPlan.expiredAt),
            description: (
              <>
                <Typography className={classes.packageDescription}>Unlimited Imaging Study Storage</Typography>
                <Typography className={classes.packageDescription2}>(12 Month Storage Subscription)</Typography>
              </>
            ),
            billingNote: (
              <>
                <span>
                  ${PaymentUtils.calculateDeluxeUpgradeFromBasic(userPlan.expiredAt)} until the end of your current subscription <br></br> period. Billed $
                  {PaymentUtils.DELUXE_PLAN.price} annually thereafter.
                </span>
              </>
            ),
          },
        ],
        standard: [
          {
            plan: PaymentUtils.DELUXE_PLAN,
            type: 'subscription',
            planName: 'Deluxe Storage',
            previousPrice: PaymentUtils.DELUXE_PLAN.price,
            price: PaymentUtils.calculateDeluxeUpgradeFromStandard(userPlan.expiredAt),
            description: (
              <>
                <Typography className={classes.packageDescription}>Unlimited Imaging Study Storage</Typography>
                <Typography className={classes.packageDescription2}>(12 Month Storage Subscription)</Typography>
              </>
            ),
            billingNote: (
              <>
                <span>
                  ${PaymentUtils.calculateDeluxeUpgradeFromStandard(userPlan.expiredAt)} until the end of your current subscription <br></br> period. Billed $
                  {PaymentUtils.DELUXE_PLAN.price} annually thereafter.
                </span>
              </>
            ),
          },
        ],
      },
    },
    requestReport: {
      title: 'Oops, looks like you have reached your maximum amount of file uploads :-(',
      btnText: 'Select Package',
      description: (
        <>
          <div className="mb-1">
            Although your video report will be kept available to you regardless of your storage capacity your Imaging Study will only be stored in your personal medical record for{' '}
            <span style={{ color: '#388E3C' }}>7 days.</span>
          </div>
          To continue storing the Imaging study for this video report consider one of the below options.
        </>
      ),
      plans: {
        basic: [
          {
            plan: PaymentUtils.STANDARD_PACKAGE,
            type: 'package',
            planName: 'Standard Package',
            previousPrice: PaymentUtils.STANDARD_PACKAGE.price,
            price: PaymentUtils.calculateUpgrade(userPlan.expiredAt, PaymentUtils.BASIC_PLAN.price, PaymentUtils.STANDARD_PACKAGE.price),
            description: (
              <>
                <Container className={`${classes.packageDescriptionContainer} mb-1`}>
                  <Typography className={classes.packageDescription}>1 Personalized Video Report</Typography>
                </Container>
                <Typography className={classes.packageDescription}>Store up to 10 Imaging Studies</Typography>
                <Typography className={classes.packageDescription2}>(6 Month Storage Upgrade)</Typography>
              </>
            ),
            billingNote: (
              <>
                <span>
                  ${PaymentUtils.calculateUpgrade(userPlan.expiredAt, PaymentUtils.BASIC_PLAN.price, PaymentUtils.STANDARD_PACKAGE.price)} until the end of your current
                  subscription <br></br> period. Billed ${PaymentUtils.STANDARD_PLAN.price} annually thereafter.
                </span>
              </>
            ),
          },
          {
            plan: PaymentUtils.DELUXE_PACKAGE,
            type: 'package',
            planName: 'Deluxe Package',
            previousPrice: PaymentUtils.DELUXE_PACKAGE.price,
            price: PaymentUtils.calculateUpgrade(userPlan.expiredAt, PaymentUtils.BASIC_PLAN.price, PaymentUtils.DELUXE_PACKAGE.price),
            description: (
              <>
                <Container className={`${classes.packageDescriptionContainer} mb-1`}>
                  <Typography className={classes.packageDescription}>1 Personalized Video Report</Typography>
                </Container>
                <Typography className={classes.packageDescription}>
                  Store <span style={{ color: '#388E3C' }}>UNLIMITED</span> Imaging Studies
                </Typography>
                <Typography className={classes.packageDescription2}>(6 Month Storage Upgrade)</Typography>
              </>
            ),
            billingNote: (
              <>
                <span>
                  ${PaymentUtils.calculateUpgrade(userPlan.expiredAt, PaymentUtils.BASIC_PLAN.price, PaymentUtils.DELUXE_PACKAGE.price)} until the end of your current subscription{' '}
                  <br></br> period. Billed ${PaymentUtils.DELUXE_PLAN.price} annually thereafter.
                </span>
              </>
            ),
          },
        ],
        standard: [
          {
            plan: PaymentUtils.DELUXE_PACKAGE,
            type: 'package',
            planName: 'Deluxe Package',
            previousPrice: PaymentUtils.DELUXE_PACKAGE.price,
            price: PaymentUtils.calculateUpgrade(userPlan.expiredAt, PaymentUtils.STANDARD_PLAN.price, PaymentUtils.DELUXE_PACKAGE.price),
            description: (
              <>
                <Container className={`${classes.packageDescriptionContainer} mb-1`}>
                  <Typography className={classes.packageDescription}>1 Personalized Video Report</Typography>
                </Container>
                <Typography className={classes.packageDescription}>
                  Store <span style={{ color: '#388E3C' }}>UNLIMITED</span> Imaging Studies
                </Typography>
                <Typography className={classes.packageDescription2}>(6 Month Storage Subscription)</Typography>
              </>
            ),
            billingNote: (
              <>
                <span>
                  ${PaymentUtils.calculateUpgrade(userPlan.expiredAt, PaymentUtils.STANDARD_PLAN.price, PaymentUtils.DELUXE_PACKAGE.price)} until the end of your current
                  subscription <br></br> period. Billed ${PaymentUtils.DELUXE_PLAN.price} annually thereafter.
                </span>
              </>
            ),
          },
        ],
      },
    },
  };
  return details[action];
};

/* eslint-enable */
export default () => {
  const classes = usePackagePlanStyles();
  const footers = {
    requestReport: (
      <Container className={`${classes.container2} mb-1`}>
        <Link component={RouterLink} className={classes.packagePopular} style={{ fontSize: '20px' }} to="/personalized-video">
          I want to request a video report without upgrading
        </Link>
      </Container>
    ),
    // MED-569: remove the package upgrade option. User can upgrade storage only
    upgrade: null,
    upgradePackage: null,
    /* upgrade: (
      <Container className={`${classes.container2} mb-1`}>
        Want an additional video report with your upgraded storage plan? &nbsp;
        <Link component={RouterLink} className={classes.packagePopular} style={{ fontSize: '20px' }} to="/upgrade-plan?action=upgradePackage">
          Show me the Video Report Packages
        </Link>
      </Container>
    ),
    upgradePackage: (
      <Container className={`${classes.container2} mb-1`}>
        Only interested in storing your Imaging Studies? &nbsp;
        <Link component={RouterLink} className={classes.packagePopular} style={{ fontSize: '20px' }} to="/upgrade-plan?action=upgrade">
          Click here for storage subscriptions
        </Link>
      </Container>
    ), */
    upload: (
      <Container className={`${classes.container2} mb-1`}>
        Alternatively, you can remove unwanted files to free up space on your current plan. &nbsp;
        <Link component={RouterLink} className={classes.packagePopular} style={{ fontSize: '20px' }} to="/patient-dashboard">
          Go to Dashboard
        </Link>
      </Container>
    ),
  };
  const blocRef = useBlocRef('upgradePlanBloc');
  const [userPlan, setUserPlan] = useState();
  const [planDetails, setPlanDetails] = useState();
  const { search } = useLocation();
  const { action } = queryString.parse(search);
  const handlePlanClick = (type, plan) => {
    switch (type) {
      case 'package':
        // MED-569: don't allow upgrading package
        blocRef.current.createSubscriptionCheckoutSession(plan);
        // blocRef.current.createPackageCheckoutSession(plan);
        break;
      case 'subscription':
        blocRef.current.createSubscriptionCheckoutSession(plan);
        break;

      default:
        break;
    }
  };
  useEffect(() => {
    const planSub = blocRef.current.userPlan$.subscribe(setUserPlan);
    return () => {
      planSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // MED-569: disable upgrading package
    // original action = "upgrade" or "upgradePackage"
    setPlanDetails(getStoragePlanDetails(userPlan, classes, 'upgrade'));
  }, [classes, userPlan]);

  return planDetails ? (
    <Container className={classes.container} style={{ paddingTop: '30px' }}>
      <Grid container justify="center" alignItems="center" direction="column">
        <Typography variant="h6" className={classes.title}>
          {planDetails.title}
        </Typography>
        <Typography variant="subtitle1" className={classes.subtitle}>
          {planDetails.description}
        </Typography>
      </Grid>

      <Grid container justify="center" className={classes.packageContainer}>
        {planDetails.plans[userPlan.name].map((plan) => (
          <Grid item xs={12} md={4} container className={classes.planWithBorder} key={plan.planName}>
            <PlanItem {...plan} btnText={planDetails.btnText} onSelect={() => handlePlanClick(plan.type, plan.plan)} />
          </Grid>
        ))}
      </Grid>
      {footers[action]}
    </Container>
  ) : null;
};
